import React from 'react';
import styled from 'styled-components';
import {
  BrowserRouter as Router,
  Route, withRouter
} from 'react-router-dom'


import Sidebar from './Sidebar';
import InfoTider from './InfoTider';
import InfoMat from './InfoMat';
import InfoPrivate from './InfoPrivat';
import { IconClose } from '../assets/icons';




const InfoView = styled.div`
 background-image: url('/bakgrundblue.svg');
-webkit-background-size: cover;
-moz-background-size: cover;
-o-background-size: cover;
background-size: cover;

height: auto;
    position: fixed;
    top: 0;
    left: 0;
    :before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background: inherit;
        z-index: -1;

        transition: all 2s linear;
        -moz-transition: all 2s linear;
        -webkit-transition: all 2s linear;
        -o-transition: all 2s linear;
    }

    @media screen and (min-width: 400px) {
      min-height: 100%;
      min-width: 1024px;
      width: 100%;
    }
    @media (max-width: 500px) {
      width: 100%;
      height:1000px;
      position: absolute;
    }
    `;
    
    const CloseButton = styled.button`
    outline: none;
    border: none;
    margin: 25px;
    padding:7.5px;
    float:right;
    border-radius: 20px;
    height:40px;
    width: 40px;
:hover:not(.active) {
  background-color: #D7EBEB;
  color: #005A4B;
}
@media (max-width: 700px) {
      display: none;
    }
`;

const routes = [
  { path: '/tider',
    // eslint-disable-next-line react/display-name
    info: () =><InfoTider/>,
  },
  { path: '/mat',
    // eslint-disable-next-line react/display-name
    info: () => <InfoMat/>,
  },
  { path: '/private',
    // eslint-disable-next-line react/display-name
    info: () => <InfoPrivate/>
  }
]


class InfoPage extends React.Component {   
  constructor(props){
      super(props); 
           
      this.routeChange = this.routeChange.bind(this);
  }
  routeChange() {
      let path = `/`;
      // eslint-disable-next-line react/prop-types
      this.props.history.push(path);
  }
    
    render () {
      return (
        <InfoView>
          <CloseButton exact={true}  onClick={()=>{ this.routeChange()}}>
            <IconClose icon='close' />
          </CloseButton>
          <Router>
           <Sidebar/>
           {routes.map((route) => (
           <Route
              key={route.path}
              path={route.path}
              component={route.info}
              />
            ))}
            </Router>
        </InfoView>
        
    );
  }
}

export default withRouter (InfoPage);